module.exports = __webpack_public_path__ + "static/media/clock.af88842a.svg";